import toast from 'jquery-toast-plugin';
$(function () {
  /*
   * 学校選択時学科取得（進学区分考慮）
   */
  $('#school_id').on('change', function () {
    if ($('#graduation_type_id').length > 0){
      var graduation_type_id = $('#graduation_type_id option:selected').val();
    } else {
      var graduation_type_id = null;
    }
    var school_course_id = $('#school_course_id option:selected').val();
    var school_id = $(this).val();
    $.ajax({
      url: '/ajax/mtb_schools/getSchoolCourses',
      type: 'GET',
      dataType: 'json',
      data: {
        'school_id': school_id,
        'graduation_type_id': graduation_type_id,
        'disable_date': true, /* 生徒からの参照時無効日を考慮 */
      }
    })
      // Ajaxリクエストが成功した時発動
      .done((data) => {
        var $select = $('#school_course_id'),
          $option,
          isSelected;
        $select.children().remove();
        $.each(data, function (value, name) {
          isSelected = (value == school_course_id);
          $option = $('<option>')
            .val(value)
            .text(name)
            .prop('selected', isSelected);
          $select.append($option);
        });
        $('#school_course_id').trigger('change');
      })
      // Ajaxリクエストが失敗した時発動
      .fail((data) => {

        $.toast({
          heading: '学科一覧取得に失敗しました',
          text: 'お手数ですが、再度お試しください',
          showHideTransition: 'slide',
          icon: 'error',
          position: 'bottom-right',
          hideAfter: 6000
        });
      })
      // Ajaxリクエストが成功・失敗どちらでも発動
      .always((data) => {

      });
  });
  /*
   * 進学区分選択時学校一覧取得
   */
  $('#graduation_type_id').on('change', function () {
    var school_id = $('#school_id option:selected').val();
    var graduation_type_id = $(this).val();
    $.ajax({
      url: '/ajax/mtb_schools/getSchools',
      type: 'GET',
      dataType: 'json',
      data: {
        'graduation_type_id': graduation_type_id,
        'disable_date': true, /* 生徒からの参照時無効日を考慮 */
      }
    })
      // Ajaxリクエストが成功した時発動
      .done((data) => {
        console.log(data);
        var $option = new Array();
        var $select = $('#school_id'),
          isSelected;
        $select.children().remove();
        $.each(data, function (kana, value) {
          var $optgroup = $('<optgroup>', {label: kana});
          $.each(value, function (id, name) {
            isSelected = (id == school_id);
            $optgroup.append($('<option>', {value: id, text: name, selected: isSelected}));
          });
          $option.push($optgroup);
        });
        console.log($option);
        $select.append($option);
        $('#school_id').trigger('change');
      })
      // Ajaxリクエストが失敗した時発動
      .fail((data) => {

        $.toast({
          heading: '学校一覧取得に失敗しました',
          text: 'お手数ですが、再度お試しください',
          showHideTransition: 'slide',
          icon: 'error',
          position: 'bottom-right',
          hideAfter: 6000
        });
      })
      // Ajaxリクエストが成功・失敗どちらでも発動
      .always((data) => {

      });
  });

});
